export const dimensions = {
  annotatorDrawerWidth: 256,
  annotatorToolDrawerWidth: 56,
  annotatorToolOptionsWidth: 200,
  stagePaddingX: 50,
  stageInfoHeight: 21,
};
